// Fixed small grid tracks allow every exhibit to keep its own natural height.
export function museumRowSpan(height, gap = 20, track = 4) {
  return Math.max(1, Math.ceil((height + gap) / track));
}
export function openMuseumStory(root, story) {
  if (!story.open) return;
  for (const other of root.querySelectorAll('.mabe-bottle details[open]')) {
    if (other !== story) other.open = false;
  }
}
if (typeof customElements !== 'undefined' && !customElements.get('mabe-museum-catalogue')) {
  customElements.define('mabe-museum-catalogue', class extends HTMLElement {
    connectedCallback() {
      this.items = [...this.querySelectorAll('[data-museum-item]')];
      this.grids = [...this.querySelectorAll('.mabe-bottle-grid')];
      this.positions = new Map();
      this.animations = new Map();
      this.abort = new AbortController();
      const options = { signal:this.abort.signal };
      this.addEventListener('toggle', event => {
        if (!event.target.matches('.mabe-bottle details')) return;
        openMuseumStory(this, event.target);
        this.queue(true);
      }, { ...options, capture:true });
      this.addEventListener('load', () => this.queue(), { ...options, capture:true });
      window.addEventListener('resize', () => this.queue(), options);
      if ('ResizeObserver' in window) {
        this.observer = new ResizeObserver(() => this.queue());
        for (const surface of this.querySelectorAll('[data-museum-surface]')) this.observer.observe(surface);
      }
      this.queue();
    }
    queue(animate = false) {
      this.animateNext ||= animate;
      if (this.frame) return;
      this.frame = requestAnimationFrame(() => {
        this.frame = null;
        if (!this.isConnected) return;
        this.layout();
      });
    }
    layout() {
      // Read natural content, then write tracks in a batch; no idle animation loop.
      const sizes = this.items.map(item => [item, museumRowSpan(item.querySelector('[data-museum-surface]').getBoundingClientRect().height + 2)]);
      for (const [item, span] of sizes) {
        const value = `span ${span}`;
        if (item.style.gridRowEnd !== value) item.style.gridRowEnd = value;
      }
      for (const grid of this.grids) grid.setAttribute('data-masonry-ready', '');
      const animate = this.animateNext && !matchMedia('(prefers-reduced-motion: reduce)').matches;
      const gridRects = new Map(this.grids.map(grid => [grid, grid.getBoundingClientRect()]));
      for (const item of this.items) {
        const grid = gridRects.get(item.parentElement);
        const current = { x:grid.left + scrollX + item.offsetLeft, y:grid.top + scrollY + item.offsetTop };
        const previous = this.positions.get(item);
        if (animate && previous && typeof item.animate === 'function') {
          this.animations.get(item)?.cancel();
          const dx = previous.x - current.x, dy = previous.y - current.y;
          if (Math.abs(dx) + Math.abs(dy) > 1) this.animations.set(item, item.animate([
            { translate:`${dx}px ${dy}px` }, { translate:'0px 0px' }
          ], { duration:240, easing:'cubic-bezier(.2,.8,.2,1)' }));
        }
        this.positions.set(item, current);
      }
      this.animateNext = false;
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.frame);
      this.observer?.disconnect();
      this.abort?.abort();
      for (const animation of this.animations.values()) animation.cancel();
    }
  });
}
